import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.036 5.354 5.207 8.183l-.012.012a.667.667 0 0 0 .012.93l1.886 1.887a.667.667 0 0 0 .943 0m0 0 2.829-2.829a.667.667 0 0 0 0-.942L8.979 5.354a.667.667 0 0 0-.943 0M4.283 7.222l2.81-2.81a2 2 0 0 1 2.828 0l1.886 1.886a2 2 0 0 1 0 2.828L8.98 11.955a2 2 0 0 1-2.828 0l-1.886-1.888a2 2 0 0 1 .018-2.845",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.873 6.488a.667.667 0 0 1 .35-.875l1.942-.832a.334.334 0 0 0 .105-.543l-1.478-1.477a.334.334 0 0 0-.56.155l-.514 2.057a.667.667 0 1 1-1.294-.323l.515-2.057a1.667 1.667 0 0 1 2.796-.775m0 0 1.477 1.477a1.666 1.666 0 0 1-.522 2.711l-2.175.887c-.338.145-.497-.066-.642-.405M5.349 9.335a.667.667 0 0 1-.35.875l-1.942.832a.333.333 0 0 0-.105.542l1.478 1.478a.335.335 0 0 0 .475-.003.33.33 0 0 0 .084-.152l.515-2.057a.667.667 0 1 1 1.293.323l-.514 2.057a1.668 1.668 0 0 1-2.796.775m0 0L2.01 12.527a1.667 1.667 0 0 1 .522-2.71l1.942-.832a.667.667 0 0 1 .876.35",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })